import { FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import MuiSelect from '@mui/material/Select';
import { ChevronDown } from 'lucide-react';
import { ReactNode, useCallback } from 'react';

export type SelectProps = {
  label: string;
  labelId: string;
  error?: boolean;
  items: { label: string; value: string }[];
  helperText?: string;
  disabled?: boolean;
  value: string;
  onChange: (value: string) => void;
  renderValue?: (value: string) => ReactNode;
};

export const Select = ({
  label,
  labelId,
  items = [],
  error,
  helperText,
  disabled,
  value,
  onChange,
  renderValue,
  ...rest
}: SelectProps) => {
  const getLabelByValue = useCallback(
    (selectedValue: string) => {
      const item = items.find((currentItem) => currentItem.value === selectedValue);
      return item?.label ?? '';
    },
    [items]
  );

  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>

      <MuiSelect
        disabled={disabled}
        labelId={labelId}
        error={error}
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
        renderValue={(selectedValue) => (renderValue ? renderValue(selectedValue) : getLabelByValue(selectedValue))}
        IconComponent={ChevronDown}
        {...rest}
      >
        {items.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </MuiSelect>

      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  );
};
